/* eslint-disable no-unused-vars */
import { getAttachmentByReference } from '../../utils/mongoUtils'
import { openAttachment } from '../../scripts/js/forgeviewer'
import { ForgeAttachment, ForgePageMarkup } from '../../scripts/js/forgeModels'
import { GET_DOCUMENTS_BY_QUERY, checkExpires, GET_DOCUMENT_TYPES_FORM_PARENT, DELETE_DOCUMENTS, UPDATE_DOCUMENT } from '../../utils/attachmentsAPI'
import store from '../index'
import HttpService from '@/utils/httpService'
const THREE = window.THREE;

export const Attachments = {
    state: {
        attachments: [],
        showAddDocumentPopup: false,
        showUpdateDocumentPopup: false,
        predefinedDocumentInfo: null,
        documentTypes: [],
        documentsIdsToUpdate: [],
        officeDocumentUrl: '',
        defaultDocumentType: 'Specifications',
        attachmentHistories: {},
    },
    mutations: {
        SET_ALL_ATTACHMENTS(state, value) {
            state.attachments = value;
        },
        SET_SHOW_ADD_DOCUMENT_POPUP(state, value) {
            state.showAddDocumentPopup = value;
        },
        SET_SHOW_UPDATE_DOCUMENT_POPUP(state, value) {
            state.showUpdateDocumentPopup = value;
        },
        SET_PREDEFINED_DOCUMENT_INFO(state, value) {
            state.predefinedDocumentInfo = value;
        },
        SET_DOCUMENTS_TYPES(state, value) {
            state.documentTypes = value;
        },
        SET_DOCUMENTS_IDS_TO_UPDATE(state, value) {
            state.documentsIdsToUpdate = value;
        },
        SET_OFFICE_DOCUMENT_URL(state, value) {
            state.officeDocumentUrl = value;
        },
        SET_DEFAULT_DOCUMENT_TYPE(state, value) {
            state.defaultDocumentType = value;
        },
        SET_ATTACHMENT_HISTORY(state, { documentId, pageId, items }) {
            var doc = state.attachmentHistories[documentId] || {};
            state.attachmentHistories = {
                ...state.attachmentHistories,
                [documentId]: { ...doc, [pageId]: items || [] },
            };
        },
        APPEND_ATTACHMENT_HISTORY_UNIQUE(state, { documentId, pageId, items }) {
            var doc = state.attachmentHistories[documentId] || {};
            var pageArr = doc[pageId] ? doc[pageId].slice() : [];

            var key = (h) =>
                `${h.type}|${h.id}|${h.actionTime ?? ''}|${h.position?.x ?? ''},${h.position?.y ?? ''}|${h.size?.x ?? ''},${h.size?.y ?? ''}`;

            var seen = new Set(pageArr.map(key));
            (items || []).forEach(it => { if (!seen.has(key(it))) pageArr.push(it); });

            state.attachmentHistories = {
                ...state.attachmentHistories,
                [documentId]: { ...doc, [pageId]: pageArr },
            };
        },
    },
    getters: {
        GET_ALL_ATTACHMENTS(state) {
            return state.attachments;
        },
        GET_SHOW_ADD_DOCUMENT_POPUP(state) {
            return state.showAddDocumentPopup;
        },
        GET_SHOW_UPDATE_DOCUMENT_POPUP(state) {
            return state.showUpdateDocumentPopup;
        },
        GET_PREDEFINED_DOCUMENT_INFO(state) {
            return state.predefinedDocumentInfo;
        },
        GET_DOCUMENT_TYPES(state) {
            return state.documentTypes;
        },
        GET_DOCUMENTS_IDS_TO_UPDATE(state) {
            return state.documentsIdsToUpdate;
        },
        GET_P_IDS(state) {
            return state.attachments.filter(a => a.documentType == "P&IDs") ?? [];
        },
        GET_OFFICE_DOCUMENT_URL(state) {
            return state.officeDocumentUrl;
        },
        GET_DEFAULT_DOCUMENT_TYPE(state) {
            return state.defaultDocumentType;
        },
        GET_ATTACHMENT_HISTORY: (state) => (documentId, pageId) =>
            state.attachmentHistories?.[documentId]?.[pageId] || [],

        GET_ATTACHMENT_HISTORY_FOR_DOC: (state) => (documentId) => {
            var pages = state.attachmentHistories?.[documentId] || {};
            var all = Object.values(pages).flat();
            var key = (h) => `${h.type}|${h.id}|${h.actionTime ?? ''}`;
            var dedup = [];
            var seen = new Set();
            for (var h of all) if (!seen.has(key(h))) { seen.add(key(h)); dedup.push(h); }
            return dedup;
        },
    },
    actions: {
        UPDATE_DOCUMENTS({ dispatch, commit, state }, { attachments }) {
            state.attachments = attachments;
        },
        REQUEST_DOCUMENT_TYPES({ dispatch, commit, state }) {
            GET_DOCUMENT_TYPES_FORM_PARENT()
                .then(types => {
                    state.documentTypes = types
                })
                .catch(error => {
                    console.log(error);
                })
        },
        REQUEST_UPDATE_DOCUMENT({ dispatch, commit, state }, document) {
            return new Promise((resolve, reject) => {
                UPDATE_DOCUMENT(document)
                    .then(a => {
                        state.attachments = [...state.attachments.filter(doc => doc.documentId != a.documentId), a];
                        resolve(a);
                    })
                    .catch(reject);
            })
        },
        UPDATE_UPLOADED_DOCUMENTS({ dispatch, commit, state }, { ids }) {
            state.documentsIdsToUpdate = [...ids];
            state.showAddDocumentPopup = false;
            state.showUpdateDocumentPopup = true;
        },
        GET_DOCUMENTS_TO_UPDATE({ dispatch, commit, state }, payload) {
            return new Promise((resolve, reject) => {
                let query = state.documentsIdsToUpdate.reduce((p, c) => {
                    return p + `documentIds=${c}&`
                }, "").slice(0, -1);

                GET_DOCUMENTS_BY_QUERY(query).then(resolve).catch(reject);
            })
        },
        CANCEL_UPDATE_POPUP({ dispatch, commit, state }, payload) {
            DELETE_DOCUMENTS(state.documentsIdsToUpdate).then(_ => {
                state.predefinedDocumentInfo = null;
                state.showUpdateDocumentPopup = false;
            });
        },
        HIDE_ADD_DOCUMENTS_POPUP({ dispatch, commit, state }, payload) {
            state.showAddDocumentPopup = false;
            state.predefinedDocumentInfo = null;
        },
        HIDE_UPDATE_DOCUMENTS_POPUP({ dispatch, commit, state }, payload) {
            state.showUpdateDocumentPopup = false;
            state.predefinedDocumentInfo = null;
        },
        DELETE_ATTACHMENTS_FROM_DATA({ dispatch, commit, state }, { ids }) {
            state.attachments = state.attachments.filter(a => !ids.includes(a.documentId));
        },
        GET_DOCUMENT_BY_REFERENCE_ID({ dispatch, commit, state }, { documentId, storageReference, name }) {
            return new Promise((resolve) => {
                getAttachmentByReference(documentId, "realityDochub").then((attachment) => {
                    checkExpires().then(_ => {
                        let cookieValue = sessionStorage.getItem('sas_token');
                        let url = `${store.state.parentBlob}${storageReference}?${cookieValue}&domain=reality.com`;
                        attachment.url = decodeURI(url);
                        attachment.name = name;
                        var forgeAttachment = Object.assign(new ForgeAttachment(), attachment);
                        if (!forgeAttachment.pagesMarkups) forgeAttachment.pagesMarkups = [];
                        forgeAttachment.pagesMarkups = forgeAttachment.pagesMarkups.map(e => Object.assign(new ForgePageMarkup(), e));
                        forgeAttachment.pagesMarkups.forEach(m => {
                            if (m.cropBox)
                                m.cropBox = Object.assign(new THREE.Box3(m.cropBox.min, m.cropBox.max));
                        })
                        resolve(forgeAttachment);
                    })
                })
            })
        },
        OPEN_ATTACHMENT_IN_VIEWER({ dispatch, commit, state }, _attachment) {
            return new Promise((resolve, reject) => {
                dispatch('GET_DOCUMENT_BY_REFERENCE_ID', {
                    documentId: _attachment.documentId,
                    storageReference: _attachment.storageReference,
                    name: _attachment.fileName
                }).then(attachment => {
                    _attachment.url = attachment.url;
                    openAttachment(attachment);
                    resolve(attachment);
                }).catch(reject);
            })
        },
        UPDATE_P_ID_TAGS({ dispatch, commit, state }, { documentId, tags }) {
            return new Promise((resolve, reject) => {
                GET_DOCUMENTS_BY_QUERY(`documentIds=${documentId}`)
                    .then((list) => {
                        let document = list[0];

                        document.equipmentTagIds = [... new Set(tags)];

                        let data = {
                            "id": document.id,
                            "assetId": document.assetId,
                            "linkedTo": document.linkedTo,
                            "documentTypeId": document.documentTypeId,
                            "equipmentTagIds": document.equipmentTagIds,
                            "documentNumber": document.documentNumber,
                            "documentTitle": document.documentTitle,
                            "revisionNumber": document.revisionNumber,
                            "tags": document.tags,
                            "isFabrication": document.isFabrication,
                            "issuedDate": document.issuedDate,
                            "fabSubDocumentIds": document.fabSubDocumentIds
                        }

                        dispatch('REQUEST_UPDATE_DOCUMENT', data);
                    })
                    .catch(reject);
            })
        },
        RequestPIdsLinkedTags({ dispatch, commit, state }) {

            let pId = store.getters.GET_DOCUMENT_TYPES.find(t => t.name === 'P&IDs')?.id;

            if (!pId) return;

            let pIds = state.attachments.filter(a => a.documentTypeId === pId);

            if (!pIds.length) return;

            let documentsIds = pIds.map(p => p.documentId);

            if (!documentsIds.length) return;

            HttpService.post({
                url: 'api/attachments/pIds/linkedTags',
                data: documentsIds
            }).then((response) => {
                let data = response.data;

                const pIds = store.getters.GET_P_IDS;

                if (!data?.length) return;

                data.forEach(document => {
                    let pIdIndex = pIds.findIndex(p => p.documentId == document.documentId);

                    if (pIdIndex < 0) return;

                    let ids = [];

                    document.links.forEach(link => {
                        let metadata = JSON.parse(link.metadata);

                        let tagId = metadata?.id;

                        if (!tagId) return;

                        ids.push(tagId);
                    });

                    pIds[pIdIndex].equipmentTagIds = [... new Set([...(pIds[pIdIndex].originalLinkedEquipmentIds ?? []), ...ids])];
                });
            }).catch((error) => {
                console.log(error);
            });
        },
        async FETCH_ATTACHMENT_HISTORY({ state, commit }, { documentId, force = false }) {
            if (!force && state.attachmentHistories?.[documentId]?.length) {
                return state.attachmentHistories[documentId];
            }

            var ts = Date.now();
            var resp = await HttpService.get({
                url: `api/forge/attachments/getAttachment/${documentId}?_=${ts}`,
            });

            var attachment = resp?.data || {};
            var pages = attachment.pagesMarkups || attachment.pagesMarkup || [];

            var parseDt = (v) => {
                if (!v) return 0;
                var t = Date.parse(v);
                return Number.isFinite(t) ? t : 0;
            };

            var makeKey = (it, pageId) => {
                var pos = it?.position ? `${it.position.x},${it.position.y}` : '';
                var size = it?.size ? `${it.size.x},${it.size.y}` : '';
                return [
                    pageId ?? '',
                    it?.type ?? '',
                    it?.id ?? '',
                    it?.actionTime ?? '',
                    pos,
                    size
                ].join('|');
            };

            var combined = [];
            var seen = new Set();

            for (var p of pages) {
                var pageId = p?.pageId ?? p?.PageId ?? null;
                var raw = p?.historyText;
                var arr = Array.isArray(raw) ? raw : JSON.parse(raw || '[]');
                if (!Array.isArray(arr)) continue;

                for (var it of arr) {
                    var item = { ...it, pageId };
                    var key = makeKey(item, pageId);
                    if (seen.has(key)) continue;
                    seen.add(key);
                    combined.push(item);
                }
            }

            combined.sort((a, b) => parseDt(a.actionTime) - parseDt(b.actionTime));

            commit('SET_ATTACHMENT_HISTORY', { documentId, items: combined.slice() });

            return combined;
        }
    },
}